import { Link } from "react-router-dom";
import { useState } from "react";
import { movieCategories } from "@/mocks/movies";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [phoneAlt, setPhoneAlt] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (phoneAlt.trim()) {
      setStatus("success");
      setEmail("");
      setPhoneAlt("");
      return;
    }

    if (!email.trim()) {
      setErrorMsg("请输入邮箱地址");
      setStatus("error");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      const formData = new FormData(e.currentTarget);
      const urlEncoded = new URLSearchParams();
      formData.forEach((val, key) => {
        if (key !== "phone_alt" || !(val as string).trim()) {
          urlEncoded.append(key, val as string);
        }
      });

      const response = await fetch("https://readdy.ai/api/form/d9njm8obdkpk99j7gkqg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: urlEncoded.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
        setPhoneAlt("");
      } else if (typeof serverMsg === "string" && serverMsg.includes("spam")) {
        setErrorMsg("订阅失败，请稍后重试");
        setStatus("error");
      } else {
        setErrorMsg(typeof serverMsg === "string" ? serverMsg : "订阅失败");
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请重试");
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="col-span-2 sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950">蓝莓影院</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 max-w-sm">
              高清免费在线观影平台，海量影视资源每日更新，电影、电视剧、动漫、综艺全覆盖，无需付费即点即看。
            </p>
            <form
              data-readdy-form
              onSubmit={handleSubscribe}
              className="flex flex-col sm:flex-row gap-2 max-w-sm"
            >
              <input
                type="text"
                name="phone_alt"
                autoComplete="off"
                tabIndex={-1}
                aria-hidden="true"
                readOnly
                className="anti-spam-field"
                value={phoneAlt}
                onChange={(e) => setPhoneAlt(e.target.value)}
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱订阅更新"
                className="flex-1 px-3 py-2 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors disabled:opacity-50"
              >
                {loading ? "提交中" : "订阅"}
              </button>
            </form>
            {status === "success" && (
              <p className="text-green-600 text-xs mt-2">订阅成功！</p>
            )}
            {status === "error" && (
              <p className="text-red-500 text-xs mt-2">{errorMsg}</p>
            )}
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">影视分类</h4>
            <ul className="space-y-2">
              {movieCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/category/dianying" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">最新电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热播电视剧</Link></li>
              <li><Link to="/category/dongman" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热门动漫</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">火爆综艺</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">联系我们</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">意见反馈</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 蓝莓影院 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}